export default function EmptyProjectsIcon() {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* building outline */}
      <rect
        x="12"
        y="20"
        width="40"
        height="36"
        rx="2"
        fill="currentColor"
        opacity="0.08"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      {/* roof / triangle */}
      <path
        d="M8 22 L32 8 L56 22"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* door */}
      <rect
        x="26"
        y="40"
        width="12"
        height="16"
        rx="1.5"
        fill="currentColor"
        opacity="0.12"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      {/* windows */}
      <rect x="16" y="28" width="8" height="7" rx="1" fill="currentColor" opacity="0.2" stroke="currentColor" strokeWidth="1.2" />
      <rect x="40" y="28" width="8" height="7" rx="1" fill="currentColor" opacity="0.2" stroke="currentColor" strokeWidth="1.2" />
      {/* search circle overlay */}
      <circle cx="48" cy="48" r="11" fill="var(--bg2, #fff)" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="47" cy="47" r="5" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <line x1="51" y1="51" x2="55" y2="55" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
